var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createApi } from '@reduxjs/toolkit/query/react';
import { produce } from 'immer';
import { sanitizeBadWords } from 'src/helpers/text';
import { useCommunityDispatch } from 'src/hooks/community-store';
import { axiosBaseQuery } from 'src/system/query/axiosQuery';
import pusher from 'src/system/services/PusherWrapper';
import { ChatType } from 'src/types/chats';
import { AppEnv } from 'src/types/system';
// Refetch when the page arg changes
function forceRefetch(_a) {
    var currentArg = _a.currentArg, previousArg = _a.previousArg;
    return (currentArg === null || currentArg === void 0 ? void 0 : currentArg.page) !== (previousArg === null || previousArg === void 0 ? void 0 : previousArg.page);
}
function serializeQueryArgs(_a) {
    var endpointName = _a.endpointName;
    return endpointName;
}
var MY_CHATS_LIMIT = 20;
var ALL_CHATS_LIMIT = 20;
// TODO Reset state on logout
export var communityChatsApi = createApi({
    reducerPath: 'communityChatsApi',
    baseQuery: axiosBaseQuery({ baseUrl: '/community/dialogs' }),
    refetchOnReconnect: true,
    tagTypes: ['Chat', 'MyChats'],
    endpoints: function (builder) { return ({
        getAllChats: builder.query({
            query: function (_a) {
                var page = _a.page, universityId = _a.universityId;
                if (universityId === 0) {
                    throw new Error('universityId is required');
                }
                var params = {
                    universityId: universityId,
                    limit: ALL_CHATS_LIMIT,
                    offset: page * ALL_CHATS_LIMIT,
                };
                if (process.env.APP_ENV === AppEnv.Staging && universityId === 103859) {
                    if (page === 0) {
                        params.pinnedDialogIds = [112436, 126683];
                    }
                    params.excludeIds = [112436, 126683];
                    params.order = 'asc';
                    params.orderBy = 'name';
                }
                else if (process.env.APP_ENV === AppEnv.Production && universityId === 522) {
                    if (page === 0) {
                        params.pinnedDialogIds = [579885, 579393];
                    }
                    params.excludeIds = [579885, 579393];
                    params.order = 'asc';
                    params.orderBy = 'name';
                }
                else if (process.env.APP_ENV === AppEnv.Production && universityId === 361) {
                    if (page === 0) {
                        params.pinnedDialogIds = [549456, 560843];
                    }
                    params.excludeIds = [549456, 560843];
                    params.order = 'asc';
                    params.orderBy = 'name';
                }
                return {
                    url: '/',
                    method: 'GET',
                    params: params,
                };
            },
            transformResponse: function (response) {
                return {
                    dialogs: response.pinnedDialogs
                        ? __spreadArray(__spreadArray([], response.pinnedDialogs, true), response.dialogs, true) : response.dialogs,
                    total: response.total,
                };
            },
            providesTags: [{ type: 'Chat', id: 'LIST' }],
            serializeQueryArgs: serializeQueryArgs,
            merge: function (oldData, newData) {
                if (!oldData)
                    return newData;
                return {
                    dialogs: __spreadArray(__spreadArray([], oldData.dialogs, true), newData.dialogs, true),
                    total: newData.total,
                };
            },
            forceRefetch: forceRefetch,
        }),
        getChat: builder.query({
            query: function (_a) {
                var id = _a.id, universityId = _a.universityId;
                if (universityId === 0 || id === 0) {
                    throw new Error('universityId or id is required');
                }
                return {
                    url: "/".concat(id),
                    method: 'GET',
                    params: { universityId: universityId },
                };
            },
            transformResponse: function (response) {
                return response.dialog;
            },
            providesTags: function (_, __, _a) {
                var id = _a.id;
                return [{ type: 'Chat', id: id }];
            },
        }),
        getMyChats: builder.query({
            query: function (_a) {
                var page = _a.page, universityId = _a.universityId, type = _a.type;
                if (universityId === 0) {
                    throw new Error('universityId is required');
                }
                var params = {
                    universityId: universityId,
                    limit: MY_CHATS_LIMIT,
                    offset: page * MY_CHATS_LIMIT,
                    type: type,
                };
                if (type === ChatType.COMMUNITY_CHAT) {
                    if (process.env.APP_ENV === AppEnv.Staging && universityId === 103859) {
                        if (page === 0) {
                            params.pinnedDialogIds = [112436, 126683];
                        }
                        params.excludeIds = [112436, 126683];
                        params.order = 'asc';
                        params.orderBy = 'name';
                    }
                    else if (process.env.APP_ENV === AppEnv.Production && universityId === 522) {
                        if (page === 0) {
                            params.pinnedDialogIds = [579885, 579393];
                        }
                        params.excludeIds = [579885, 579393];
                        params.order = 'asc';
                        params.orderBy = 'name';
                    }
                    else if (process.env.APP_ENV === AppEnv.Production && universityId === 361) {
                        if (page === 0) {
                            params.pinnedDialogIds = [549456, 560843];
                        }
                        params.excludeIds = [549456, 560843];
                        params.order = 'asc';
                        params.orderBy = 'name';
                    }
                }
                return {
                    url: '/my',
                    method: 'GET',
                    params: params,
                };
            },
            providesTags: function (_, __, _a) {
                var type = _a.type;
                return [{ type: 'MyChats', id: type }];
            },
            serializeQueryArgs: function (_a) {
                var endpointName = _a.endpointName, queryArgs = _a.queryArgs;
                return "".concat(endpointName, "-").concat(queryArgs.type);
            },
            transformResponse: function (response) {
                return produce(response, function (draft) {
                    var _a;
                    draft.dialogs.forEach(function (chat) {
                        var _a;
                        chat.lastMessage = ((_a = chat.lastMessage) === null || _a === void 0 ? void 0 : _a.text)
                            ? {
                                text: sanitizeBadWords(chat.lastMessage.text),
                            }
                            : null;
                    });
                    if (draft.pinnedDialogs) {
                        draft.pinnedDialogs.forEach(function (chat) {
                            var _a;
                            chat.lastMessage = ((_a = chat.lastMessage) === null || _a === void 0 ? void 0 : _a.text)
                                ? {
                                    text: sanitizeBadWords(chat.lastMessage.text),
                                }
                                : null;
                            if (!chat.avatar) {
                                chat.avatar = 'https://cdn.theaccessplatform.com/img/community_chat_default.jpg';
                            }
                        });
                        (_a = draft.dialogs).unshift.apply(_a, draft.pinnedDialogs);
                    }
                });
            },
            merge: function (oldData, newData) {
                if (!oldData)
                    return newData;
                return {
                    dialogs: __spreadArray(__spreadArray([], oldData.dialogs, true), newData.dialogs, true),
                    total: newData.total,
                };
            },
            forceRefetch: forceRefetch,
            onCacheEntryAdded: function (_, _a) {
                var _b;
                var cacheDataLoaded = _a.cacheDataLoaded, updateCachedData = _a.updateCachedData, cacheEntryRemoved = _a.cacheEntryRemoved, getState = _a.getState;
                return __awaiter(this, void 0, void 0, function () {
                    var userId, channel;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, cacheDataLoaded];
                            case 1:
                                _c.sent();
                                userId = (_b = getState().communityAccount.accountInfo) === null || _b === void 0 ? void 0 : _b.id;
                                if (!userId) {
                                    return [2 /*return*/];
                                }
                                channel = pusher.subscribe("community-user-".concat(userId));
                                channel.bind('new-message', function (data) {
                                    updateCachedData(function (draft) {
                                        var chat = draft.dialogs.find(function (d) { return d.id === data.dialogId; });
                                        if (chat) {
                                            chat.unreadCount = data.newMessages;
                                        }
                                    });
                                });
                                return [4 /*yield*/, cacheEntryRemoved];
                            case 2:
                                _c.sent();
                                channel.unbind('new-message');
                                channel.unsubscribe();
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
        joinToChat: builder.mutation({
            query: function (_a) {
                var chat = _a.chat, universityId = _a.universityId;
                if (universityId === 0 || chat.id === 0) {
                    throw new Error('universityId or chatId is required');
                }
                return {
                    url: "/".concat(chat.id, "/join"),
                    method: 'POST',
                    data: { universityId: universityId },
                };
            },
            invalidatesTags: [{ type: 'Chat', id: 'LIST' }],
            onQueryStarted: function (_a, _b) {
                var chat = _a.chat, universityId = _a.universityId;
                var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                var getMyChats = dispatch(communityChatsApi.util.updateQueryData('getMyChats', { universityId: universityId, page: 0, type: ChatType.COMMUNITY_CHAT }, function (draft) {
                    var _a;
                    var index = draft.dialogs.findIndex(function (d) { return d.id === chat.id; });
                    if (index === -1) {
                        draft.dialogs.unshift({
                            id: chat.id,
                            description: chat.description,
                            name: chat.name,
                            lastMessage: ((_a = chat.lastMessage) === null || _a === void 0 ? void 0 : _a.content) || null,
                            unreadCount: 0,
                            avatar: chat.avatar,
                        });
                    }
                }));
                queryFulfilled
                    .then(function () {
                    dispatch(communityChatsApi.util.updateQueryData('getChat', { id: chat.id, universityId: universityId }, function (draft) {
                        draft.isMember = true;
                        draft.membersCount += 1;
                    }));
                })
                    .catch(function () {
                    getMyChats.undo();
                });
            },
        }),
        leaveFromChat: builder.mutation({
            query: function (_a) {
                var chatId = _a.chatId, universityId = _a.universityId;
                if (universityId === 0 || chatId === 0) {
                    throw new Error('universityId or chatId is required');
                }
                return {
                    url: "/".concat(chatId, "/leave"),
                    method: 'DELETE',
                    params: { universityId: universityId },
                };
            },
            onQueryStarted: function (arg, _a) {
                var dispatch = _a.dispatch, queryFulfilled = _a.queryFulfilled;
                queryFulfilled.then(function () {
                    dispatch(communityChatsApi.util.invalidateTags([
                        { type: 'Chat', id: 'LIST' },
                        { type: 'Chat', id: arg.chatId },
                    ]));
                    dispatch(communityChatsApi.util.updateQueryData('getMyChats', { universityId: arg.universityId, page: 0, type: ChatType.COMMUNITY_CHAT }, function (draft) {
                        var index = draft.dialogs.findIndex(function (d) { return d.id === arg.chatId; });
                        if (index !== -1) {
                            draft.dialogs.splice(index, 1);
                            draft.total -= 1;
                        }
                    }));
                });
            },
        }),
        markAsRead: builder.mutation({
            query: function (_a) {
                var id = _a.id;
                return {
                    url: "/".concat(id, "/messages/view"),
                    method: 'POST',
                };
            },
            onQueryStarted: function (_a, _b) {
                var id = _a.id, type = _a.type;
                var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _c.sent();
                                dispatch(resetChatCounter(id, type));
                                return [2 /*return*/];
                        }
                    });
                });
            },
        }),
    }); },
});
export function resetChatCounter(chatId, type) {
    return communityChatsApi.util.updateQueryData('getMyChats', { universityId: 0, page: 0, type: type }, function (draft) {
        var chat = draft.dialogs.find(function (d) { return d.id === chatId; });
        if (chat) {
            chat.unreadCount = 0;
        }
    });
}
export function useUpdatePersonalChatList() {
    var dispatch = useCommunityDispatch();
    return function (chat, universityId) {
        if (universityId === void 0) { universityId = 0; }
        dispatch(communityChatsApi.util.updateQueryData('getMyChats', { universityId: universityId, page: 0, type: ChatType.COMMUNITY_1_TO_1_CHAT }, function (draft) {
            var index = draft.dialogs.findIndex(function (d) { return d.id === chat.id; });
            if (index === -1) {
                draft.dialogs.unshift(chat);
            }
            else {
                draft.dialogs[index] = chat;
            }
        }));
    };
}
export var useGetAllChatsQuery = communityChatsApi.useGetAllChatsQuery, useGetMyChatsQuery = communityChatsApi.useGetMyChatsQuery, useGetChatQuery = communityChatsApi.useGetChatQuery, useJoinToChatMutation = communityChatsApi.useJoinToChatMutation, useLeaveFromChatMutation = communityChatsApi.useLeaveFromChatMutation, useMarkAsReadMutation = communityChatsApi.useMarkAsReadMutation;
